const honor = {
    getlist: 'honor/getlist-by-admin',
    add: 'honor/add',
    update: 'honor/update',
    remove: 'honor/remove',
    get: 'honor/get-by-admin',
    getall: 'honor/getall-by-admin',
    clearcache: 'honor/clear-cache',
}
export default honor